<template>
    <div class="uk-padding uk-background-muted">
        <div class="uk-container">
            <h1 class="uk-text-center" style="color: #004e9c;">Our Products</h1>
            <br>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <video src="../../assets/AeorionSoftwareSolutions.mp4" controls playsinline uk-video="autoplay: inview; automute: true" ></video>
                    <!--<iframe width="100%" height="450" src="https://www.youtube.com/embed/ZKVz7LQzIzg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                --></div>
                <div>
                    <h3 class="uk-heading-bullet" style="color: #800">Aeorion SMS </h3>
                    <p class="uk-text-small uk-text-muted">
                        Enjoy complete management of your entire academic administration functions from online
                        application to graduation, using the best culturally contextual Student Management System
                        available locally today.
                    </p>
                    <p>Core system features include:</p>
                    <ul class="uk-list uk-list-divider uk-list-bullet">


                        <li class="uk-text-small">Integrated Learning Management System</li>
                        <li class="uk-text-small">Admissions Module
                            <span class="uk-text-muted ">
                                (now includes functions for electronic document management and
                            more...)
                            </span>
                        </li>
                        <li class="uk-text-small">
                            Registry Management
                            <span class="uk-text-muted uk-text-small">
                                (automated generation of grade reports, transcripts, graduation list
                            and more...)
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <router-link to="/productservices" class="uk-button uk-button-link uk-align-right uk-text-capitalize " style="color: #800; font-size: medium">
                    See More Products & Services
                    <span uk-icon="chevron-double-right"></span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "productsSnip"
    }
</script>

<style scoped>

</style>